import React from 'react';
import Select from 'react-select';
// import '../styles/CustomStyle.scss';
// import 'react-select/dist/react-select.css';


class SmartSelect extends React.Component {
    constructor(props) {
        super(props);
        this.setValue = this.setValue.bind(this);
        this.SmartSelectRef = React.createRef();
        var labelVal = this.getLabel(this.props.values, this.props.node.data[this.props.colDef.field]);
        this.state = {
            values: props.values,
            selectedValue: { label: labelVal, value: this.props.node.data[this.props.colDef.field] }
        };
    };
    getLabel(values, selectedValue) {
        if (selectedValue === null || selectedValue === undefined || values === undefined || values === null || !values.find(x => x.value === selectedValue.toString()))
            return null;
        return values.find(x => x.value === selectedValue.toString()).label;
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ values: nextProps.values });
    };

    isPopup() {
        return typeof this.props.isPopup === "boolean" ? this.props.isPopup : false;
    }


    render() {
        return (
            <div style={{ width: this.isPopup() ? this.props.column.getActualWidth() : "100%", display: "relative" }}>
                <div className="dropdown smart-select-dropdown" >
                    <div  >
                        <Select
                            options={this.props.values}
                            value={this.state.selectedValue}
                            onChange={(selected) => {
                                this.props.node.setDataValue(this.props.colDef.field, selected.value);
                                this.setState({ selectedValue: selected });
                                if (this.props.colDef.ChildDependencyField) {
                                    this.props.api.stopEditing(true);
                                    setTimeout(function () { //Start the timer
                                        this.props.api.startEditingCell({
                                            rowIndex: this.props.node.rowIndex,
                                            // gets the first columnKey
                                            colKey: this.props.columnApi.getDisplayedCenterColumns()[1].colId
                                        });
                                        let cols = this.props.columnApi.getAllDisplayedColumns();
                                        const NonPinnedColumn = cols.filter(x => !x.pinned);
                                        this.props.api.ensureColumnVisible(NonPinnedColumn[0]);
                                    }.bind(this), 50)
                                }
                                //this.props.node.setDataValue(this.props.colDef.field, selected.value);  

                            }}
                            className='react-select-button'
                            menuColor='red'
                        />
                    </div>
                </div>
            </div>


        );
    };

    componentDidMount() {
    };

    setValue(val) {
    }

};

export default SmartSelect;